import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { loadSelectedSchool } from 'tio-common/utils/tuition-assistance/application-new-route';
import { loadIsRestrictedByProgramExclusivity } from 'tio-common/utils/tuition-assistance/tas-grouping';
import { loadTasProgramInstanceHistory } from 'tio-data/requests/tas-program-instance';
// This is for types. Anything we have custom may show an error.
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store as StoreService } from '@warp-drive/core';
import type { TasProgramInstanceExtension as TasProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { TasGroup as TasGroupModel } from 'tio-data/data/resources/tas-group.type';
import { query } from '@warp-drive/utilities/json-api';

export default class AuthenticatedTasProgramsNewGuidedRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const { programInstance } = this.modelFor('authenticated.tas.programs') as {
      programInstance: TasProgramInstanceModel;
    };

    const selectedSchool = await loadSelectedSchool(programInstance, this.store);

    const { content: tasGroupsContent } = (await this.store.request(
      query<TasGroupModel>('tas-group', {
        'filter[company]': this.sessionContext.currentEmployee.company.id,
        'filter[flavor]': 'TAS.GroupFlavor.MUTUALLY_EXCLUSIVE',
        include: 'tas-groupings.tas-program-template',
      })
    )) as { content: { data: TasGroupModel[] } };

    const isRestrictedByProgramExclusivity = await loadIsRestrictedByProgramExclusivity(
      this.store,
      this.sessionContext.currentEmployee.id,
      tasGroupsContent.data,
      programInstance.tasProgramTemplate?.id
    );

    try {
      await loadTasProgramInstanceHistory(this.store, programInstance);
    } catch (e) {
      // History is non-critical — don't block the route
      console.error('Error loading program instance history', e);
    }

    return {
      programInstance: programInstance,
      selectedSchool: selectedSchool,
      isRestrictedByProgramExclusivity: isRestrictedByProgramExclusivity,
    };
  }
}
